import { render } from "./PrivacyPolicy.vue?vue&type=template&id=9a567268"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=9a567268&lang=css"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__